import React from 'react'
import {useTranslation} from '@lib/intl/useTranslations'
import IconNoti from '@svg/common/ic_noti.svg'
import TagText from '@component/Text/TagText'
import WizIcon from '@component/images/WizIcon'

const NotificationCopyTradingContainer = () => {
    const t = useTranslation()

    return (
        <div className={'py-[30px] space-y-[10px] min-w-[800px]'}>
            <WizIcon className={'mx-auto w-min p-[15px]'} backgroundColorType={'gray'}>
                <IconNoti className={'w-[40px] fill-gray02 dark:fill-dark_gray02'} />
            </WizIcon>
            <TagText className={'text-gray02 dark:text-dark_gray02 text-body2 text-center'}>
                {t('globalNotification.emptyData.text')}
            </TagText>
        </div>
    )
}

export default NotificationCopyTradingContainer
